module.exports = __webpack_public_path__ + "img/code_online.0c3b2a1b.png";